<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-chevron-down" />
</template>

<style scoped></style>
